import React, { createContext, useState } from 'react'

import { Modal } from 'antd'
import { connect } from 'react-redux'
import { isFunction, isObject } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import { onError, onSuccess } from '../../../utils/apiHelper'
import { createInternships, createInternshipWithoutStudent, updateInternshipOld } from '../../../utils/api/internship'
import AutonomousInternshipForm from './AutonomousInternshipForm'
import { InternshipValidators } from '../../../utils/entities/internship'
import { selectValidators } from '../../../utils/validators'
import { Actions } from '../../../utils/events'
import { isSchoolUser } from '../../../utils/roles'

export const AutonomousInternshipFormModalContext = createContext()

export const Modes = Object.freeze({
  CREATE: 1,
  UPDATE: 2,
  EDIT_SECTOR: 3
})

const DEFAULT_DATA = {
  object: null,
  callback: null,
  mode: null
}

const mapStateToProps = state => ({
  user: selectUser(state),
  t: selectTranslate(state)
})

const AutonomousInternshipFormModal = ({ children, user, sectors = [], keysToValidate = [], t }) => {
  const [data, setData] = useState(DEFAULT_DATA)

  const handleSubmit = updatedInternship => {
    const isBulk = Array.isArray(updatedInternship)

    const configFactories = {
      [Modes.CREATE]: () => isBulk
        ? { action: Actions.CREATE, promise: createInternships, parameters: [user, updatedInternship.map(internship => internship.toRequestBody())] }
        : {
            action: Actions.CREATE,
            promise: isSchoolUser(user) ? createInternships : createInternshipWithoutStudent,
            parameters: [user, updatedInternship.toRequestBody()]
          },
      [Modes.UPDATE]: () => ({ action: Actions.UPDATE, promise: updateInternshipOld, parameters: [updatedInternship, updatedInternship.toRequestBody(), user] }),
      [Modes.EDIT_SECTOR]: () => ({ action: Actions.UPDATE, promise: updateInternshipOld, parameters: [updatedInternship, { sector: updatedInternship.toRequestBody().sector }, user] })
    }

    const handler = configFactories[data.mode]()

    handler.promise(...handler.parameters).then(json => {
      // updateInternshipOld resolves undefined on an HTTP error instead of rejecting.
      if (!json?.data) {
        onError(t(`internship_form.${handler.action.toLowerCase()}.error`))

        return
      }

      if (isFunction(data.callback)) {
        data.callback(json.data)
      }

      setData(DEFAULT_DATA)
      onSuccess(t(`internship_form.${handler.action.toLowerCase()}.success`))
    }).catch(error => {
      console.error(error)
      onError(t(`internship_form.${handler.action.toLowerCase()}.error`))
    })
  }

  const validators = selectValidators(InternshipValidators, keysToValidate)

  return (
    <>
      <AutonomousInternshipFormModalContext.Provider value={{ setData }}>
        {children}
      </AutonomousInternshipFormModalContext.Provider>
      <Modal
        className='form-modal'
        title={t('internship_form.title')}
        visible={isObject(data.object)}
        onCancel={() => setData(DEFAULT_DATA)}
        destroyOnClose
        footer={null}
        width={700}
      >
        {isObject(data.object) && (
          <AutonomousInternshipForm
            data={data.object}
            mode={data.mode}
            sectors={sectors}
            validators={validators}
            onSubmit={handleSubmit}
            onCancel={() => setData(DEFAULT_DATA)}
          />
        )}
      </Modal>
    </>
  )
}

export default connect(mapStateToProps)(AutonomousInternshipFormModal)
